import Logo from './Logo';

const values = [
  { label: 'Creative First', icon: '🎨' },
  { label: 'Data Driven', icon: '📊' },
  { label: 'Client Focused', icon: '🤝' },
  { label: 'Always Evolving', icon: '⚡' },
];

const About = () => (
  <section className="section about" id="about">
    <div className="container about-grid">
      <div className="about-visual reveal">
        <div className="about-logo-wrap">
          <Logo height={180} />
          <div className="about-ring" />
          <div className="about-ring about-ring--2" />
        </div>
        <div className="about-badges">
          <div className="about-badge">
            <span className="badge-num red">2024</span>
            <span className="badge-label">Founded</span>
          </div>
          <div className="about-badge">
            <span className="badge-num red">8+</span>
            <span className="badge-label">Services</span>
          </div>
          <div className="about-badge about-badge--wide">
            <span className="badge-label">Africa's Leading Digital Agency</span>
          </div>
        </div>
      </div>

      <div className="about-text reveal" data-delay="150">
        <span className="section-tag">Who We Are</span>
        <h2>A Creative Agency That <span className="red">Delivers Results</span></h2>
        <p>
          Raddish Media is a full-service media and marketing agency dedicated to helping
          businesses grow through bold creativity and strategic thinking. We combine
          storytelling, design, and data to craft campaigns that connect, engage, and convert.
        </p>
        <p>
          Whether you're a startup finding your voice or an established brand ready to
          scale, we bring the expertise, passion, and tools to take your presence to the
          next level.
        </p>
        <div className="about-values">
          {values.map((v, i) => (
            <div className="about-value reveal" key={v.label} data-delay={i * 80}>
              <span className="value-icon">{v.icon}</span>
              <span>{v.label}</span>
            </div>
          ))}
        </div>
        <button
          className="btn-primary"
          onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
        >
          Work With Us
        </button>
      </div>
    </div>
  </section>
);

export default About;
